import { WEBFLOW_SCRIPT_ENV } from '../src/webflow-script-env';
import { closeCart } from './closeCart';
import { getCartSKU } from './getCartSKU';
import { getCloseUpsellCartObserver } from './getCloseUpsellCartObserver';
import { prepareUpsellStyles } from './prepareUpsellStyles';
import { shouldShowUpsell } from './shouldShowUpsell';
import { simulateClick } from './simulateClick';
import { upsellElements } from './upsellElements';

export const getShowUpsellObserver = (cartProductId: string) => {
  try {
    const { cartModal, cartWrapper, openUpsellArray } = upsellElements();
    //On Webflow you can't have the cart modal without the cart wrapper,
    //but still test
    if (cartModal && !cartWrapper) {
      if (WEBFLOW_SCRIPT_ENV !== 'production') {
        throw new Error('Cart modal found without cart wrapper');
      }
    }

    if (!cartModal && cartWrapper) {
      if (WEBFLOW_SCRIPT_ENV !== 'production') {
        throw new Error('Cart wrapper found without cart modal');
      }
    }

    if (cartModal && cartWrapper && openUpsellArray && openUpsellArray[0]) {
      const showUpsellObserver = new MutationObserver(function (mutations) {
        mutations.forEach(async (mutation) => {
          //Note this function will fire for each cartSKU in cart
          const cartSKU = getCartSKU(mutation);
          if (cartSKU) {
            const { showUpsell, upsellProductId } = shouldShowUpsell(
              cartSKU,
              cartProductId
            );

            if (showUpsell && upsellProductId) {
              const stylesSet = prepareUpsellStyles(upsellProductId);

              if (stylesSet) {
                closeCart(showUpsellObserver);

                // start a new cart observer for clean up.
                const closeUpsellObserver = getCloseUpsellCartObserver();

                if (closeUpsellObserver) {
                  closeUpsellObserver.observe(cartWrapper, {
                    attributes: true,
                    childList: true,
                    subtree: true,
                  });
                }

                simulateClick(openUpsellArray[0]);

                //Handles opening cart if upsell is closed
                const openCart = (evt: MouseEvent): void => {
                  const closeButton = (evt.target as unknown) as HTMLElement;
                  closeButton.removeEventListener('click', openCart);

                  const toggleCartButtonArray = document.querySelectorAll(
                    '[data-node-type="commerce-cart-open-link"]'
                  );
                  const toggleCartButton = toggleCartButtonArray[0];

                  simulateClick(toggleCartButton);
                };

                const closeUpsellArray = (document.querySelectorAll(
                  '[data-fp="upsell-close"]'
                ) as unknown) as HTMLElement[];

                for (const button of closeUpsellArray) {
                  button.addEventListener('click', openCart);
                }
              }
            }
          }
        });
      });

      return showUpsellObserver;
    } else {
      return undefined;
    }
  } catch (error) {
    throw error;
  }
};
